// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import { withRequired } from '../../validators';
import { ReduxFormHidden } from '../../../form/hidden';
import { getConfiguration } from '../../../../store/configuration/actives/selectors/configuration';
import { getCartPrice } from '../../../../store/configuration/cart/selectors';
import type { CartPrice } from '../../../../store/configuration/cart/types';

type OwnProps = {|
  formName: string,
  name: string,
  dispatch: Function,
|};

type StateProps = {|
  carConfiguration: Object,
  carPrice: CartPrice,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

class ConfigurationField extends Component<Props> {
  constructor(props) {
    super(props);
    const {
      dispatch, formName, name, carConfiguration, carPrice,
    } = this.props;

    dispatch(change(
      formName,
      name,
      {
        configuration: carConfiguration,
        price: carPrice,
      },
    ));
  }

  render() {
    const { name } = this.props;
    return (
      <Field
        component={ReduxFormHidden}
        name={name}
      />
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  carConfiguration: getConfiguration(state),
  carPrice: getCartPrice(state),
});

export default withRequired<Props>(
  connect<any, OwnProps, StateProps, any, any, any>(
    mapStateToProps,
  )(ConfigurationField),
);
